export default __webpack_public_path__ + "static/media/woman-painting.3e1f1fcf.jpg";